export enum noteTabs {
  GENERAL_NOTES,
  INDIVIDUAL_WORKSPACES,
  MEETING_SPACES,
  AMENITY_SPACES,
  SUPPORT_SPACES,
}
